export const ItemsDisplayMode = {
  Icons: 'icons',
  Titles: 'titles',
  IconsTitles: 'icons_titles',
};
